import { Avatar, Box, Drawer, IconButton, Link, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import useResponsive from "../../../hooks/useResponsive";
import { useEffect } from "react";
import Scrollbar from "../../../components/scrollbar/Scrollbar";
import NavSection from "../../../components/nav-section/NavSection";
import { styled, alpha } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import useNavConfig from "./config";
import LOGO from '../../../assets/images/ant-logo-final.jpeg';
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useTranslation } from "react-i18next";
import { IMAGE_ADMIN_PROFILE } from "../../../lib/endpoints/profileImage";

interface Props {
    openNav: boolean,
    onCloseNav: VoidFunction,
    openNavDesktopScreen: boolean,
    isLgScreen: boolean,
    onCloseNavDesktopScreen: VoidFunction
}

const NAV_WIDTH: number = 280;

const StyledAccount = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

const Nav = ({ openNav, onCloseNav, openNavDesktopScreen, isLgScreen, onCloseNavDesktopScreen }: Props) => {
    const { pathname } = useLocation();
    const userData = useSelector((state: RootState) => state?.auth?.data);

    const { t } = useTranslation('global')

    const { navConfig } = useNavConfig();

    const isDesktop: boolean = useResponsive('up', 'lg', null!);

    const renderContent = (
        <Scrollbar
            sx={{
                height: 1,
                '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },

            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                <IconButton onClick={() => {
                    if (isLgScreen) {
                        onCloseNavDesktopScreen();
                    }
                    else {
                        onCloseNav();
                    }
                }}><CloseIcon sx={{ fontSize: 20 }} /></IconButton>
            </Box>
            <Box sx={{ height: '180px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    {/* <Logo /> */}
                    <img src={LOGO} alt="" style={{
                        width: 70,
                        height: 'auto',
                        borderRadius: '10px',
                        marginBottom: "10px"
                    }} />

                </Box>

                <Box sx={{ mb: 5, mx: 2.5 }}>
                    <Link underline="none">
                        <StyledAccount>
                            <Avatar src={IMAGE_ADMIN_PROFILE + userData?.profile?.image?.url} alt={""} />
                            <Box sx={{ ml: 2 }}>
                                <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                                    {userData?.username}
                                </Typography>

                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    <span>{userData?.role?.role_type === 'SUPER_ADMIN' ? t('Super Admin') : userData?.role?.role_type === 'ADMIN' ? t('Admin') : "Hr"}</span>
                                </Typography>
                            </Box>
                        </StyledAccount>
                    </Link>
                </Box>
            </Box>

            <NavSection data={navConfig} />

            <Box sx={{ flexGrow: 1 }} />

        </Scrollbar>
    );

    useEffect(() => {
        if (openNav) {
            onCloseNav();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname])

    return <Box
        component="nav"
        sx={{
            flexShrink: { lg: 0 },
            width: { lg: NAV_WIDTH }
        }}
    >
        {
            isDesktop
                ?

                <Drawer open={openNavDesktopScreen} variant={openNavDesktopScreen ? "permanent" : "temporary"} PaperProps={{
                    sx: {
                        width: NAV_WIDTH,
                        bgcolor: 'background.default',
                        borderRightStyle: 'dashed',
                    },
                }}>
                    {renderContent}
                </Drawer>
                :
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    PaperProps={{
                        sx: { width: NAV_WIDTH },
                    }}
                >
                    {renderContent}
                </Drawer>
        }
    </Box>
}
export default Nav;